import type { EventCategory } from "./events";

// Géneros de TMDB (IDs, iguales en todos los idiomas) → categorías de evento
// afines, para la fila de eventos del detalle de Viva Cine. Películas y series
// tienen listas de géneros distintas en TMDB; acá van juntas porque los IDs no
// chocan. Un género sin entrada no aporta afinidad (acción, terror…): la fila
// muestra eventos próximos de cualquier categoría.
const GENRE_TO_CATEGORIES: Record<number, EventCategory[]> = {
  10402: ["Música"], // Música
  10751: ["Familia", "Niños"], // Familia
  16: ["Familia", "Niños"], // Animación
  10762: ["Niños", "Familia"], // Infantil (series)
  99: ["Cultura"], // Documental
  36: ["Cultura"], // Historia
  18: ["Cultura"], // Drama
};

// Categorías afines en orden de prioridad (sin repetir): sigue el orden de
// los géneros que entrega TMDB, el principal primero.
export function eventCategoriesForGenres(genreIds: number[] | undefined): EventCategory[] {
  const result: EventCategory[] = [];
  for (const id of genreIds ?? []) {
    for (const category of GENRE_TO_CATEGORIES[id] ?? []) {
      if (!result.includes(category)) result.push(category);
    }
  }
  return result;
}
